/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Ar as Ar,
  rec_AvatarPersona as AvatarPersona,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_jx as jx,
  rec_kr as kr,
  rec_kx as kx,
} from "../../runtime/index.jsx";
export function SelectorMultiple(e) {
  let t = (0, ReactCompiler.c)(34),
    n,
    r,
    i,
    a,
    o,
    s,
    c;
  t[0] === e
    ? ((n = t[1]),
      (r = t[2]),
      (i = t[3]),
      (a = t[4]),
      (o = t[5]),
      (s = t[6]),
      (c = t[7]))
    : (({
        value: c,
        onChange: n,
        opciones: i,
        placeholder: a,
        className: o,
        disabled: s,
        ...r
      } = e),
      (t[0] = e),
      (t[1] = n),
      (t[2] = r),
      (t[3] = i),
      (t[4] = a),
      (t[5] = o),
      (t[6] = s),
      (t[7] = c));
  let l;
  t[8] === i
    ? (l = t[9])
    : ((l = i === void 0 ? [] : i), (t[8] = i), (t[9] = l));
  let u = l,
    f = a === void 0 ? `Todos` : a,
    p = o === void 0 ? `` : o,
    m = s !== void 0 && s,
    h = Object.keys(r);
  h.length > 0 &&
    console.error(
      `SelectVanguard no conoce ${h.join(`, `)}. La lista de opciones se pasa en \`opciones\`.`,
    );
  let [_, v] = (0, React.useState)(!1),
    y = (0, React.useRef)(null),
    b;
  if (t[10] !== u || t[11] !== c) {
    let e;
    (t[13] === c
      ? (e = t[14])
      : ((e = (e) => e.value === c), (t[13] = c), (t[14] = e)),
      (b = u.find(e)),
      (t[10] = u),
      (t[11] = c),
      (t[12] = b));
  } else b = t[12];
  let x = b,
    S;
  (t[15] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((S = () => v(!1)), (t[15] = S))
    : (S = t[15]),
    kx(_, y, S));
  let C = `relative ${p}`,
    w;
  t[16] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((w = () => v(jx)), (t[16] = w))
    : (w = t[16]);
  let T = `truncate ${x ? `text-(--text-h)` : `text-(--text)/70`}`,
    E = x ? x.label : f,
    D;
  t[17] !== T || t[18] !== E
    ? ((D = <span className={T} children={E} />),
      (t[17] = T),
      (t[18] = E),
      (t[19] = D))
    : (D = t[19]);
  let O;
  t[20] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((O = <Ar className={`h-4 w-4 shrink-0 text-(--text)`} />), (t[20] = O))
    : (O = t[20]);
  let k;
  t[21] !== m || t[22] !== D
    ? ((k = (
        <button
          type={`button`}
          disabled={m}
          onClick={w}
          className={`flex w-full items-center justify-between gap-2 rounded-2xl border border-(--border) bg-(--bg) px-3 py-2 text-sm outline-none transition focus:border-(--accent-border) focus:ring-2 focus:ring-(--accent-bg) disabled:cursor-not-allowed disabled:opacity-60`}
          children={[D, O]}
        />
      )),
      (t[21] = m),
      (t[22] = D),
      (t[23] = k))
    : (k = t[23]);
  let A;
  t[24] !== _ || t[25] !== n || t[26] !== u || t[27] !== f || t[28] !== c
    ? ((A = _ && (
        <AvatarPersona
          anclaRef={y}
          className={`rounded-2xl border border-(--border) bg-(--bg) shadow-2xl`}
          children={
            <ul
              children={[
                <li
                  children={
                    <button
                      type={`button`}
                      onClick={() => {
                        (n(``), v(!1));
                      }}
                      className={`flex w-full items-center justify-between px-3 py-2 text-left text-sm text-(--text) transition hover:bg-(--accent-bg)`}
                      children={[
                        f,
                        !c &&
                          (0, JSXRuntime.jsx)(kr, {
                            className: `h-4 w-4 text-(--accent)`,
                          }),
                      ]}
                    />
                  }
                />,
                u.map((e) => (
                  <li
                    key={e.value}
                    children={
                      <button
                        type={`button`}
                        onClick={() => {
                          (n(e.value), v(!1));
                        }}
                        className={`flex w-full items-center justify-between px-3 py-2 text-left text-sm text-(--text-h) transition hover:bg-(--accent-bg)`}
                        children={[
                          <span className={`truncate`} children={e.label} />,
                          e.value === c &&
                            (0, JSXRuntime.jsx)(kr, {
                              className: `h-4 w-4 shrink-0 text-(--accent)`,
                            }),
                        ]}
                      />
                    }
                  />
                )),
              ]}
            />
          }
        />
      )),
      (t[24] = _),
      (t[25] = n),
      (t[26] = u),
      (t[27] = f),
      (t[28] = c),
      (t[29] = A))
    : (A = t[29]);
  let j;
  return (
    t[30] !== k || t[31] !== A || t[32] !== C
      ? ((j = <div className={C} ref={y} children={[k, A]} />),
        (t[30] = k),
        (t[31] = A),
        (t[32] = C),
        (t[33] = j))
      : (j = t[33]),
    j
  );
}
